import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Button, ButtonToolbar, PanelGroup, Tooltip, OverlayTrigger} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import DefineInterventionPeriodPanel from './DefineInterventionPeriodPanel'
import UpdateInterventionPeriodPanel from './UpdateInterventionPeriodPanel'
import AssignActivityToProviderCompanyModal from './AssignActivityToProviderCompanyModal'
import UnAssignActivityFromProviderCompanyModal from './UnAssignActivityFromProviderCompanyModal'
import RemoveInterventionPeriodModal from './RemoveInterventionPeriodModal'
import CopyInterventionPeriodsModal from './CopyInterventionPeriodsModal'
import style from './CommitmentLayout.less'

function modalName(result) {
    switch (result) {
        case 'RemoveInterventionPeriod':
            return 'RemoveInterventionPeriodModal'
        default:
            return result
    }
}

function interventionPeriodSorter(a, b) {
    if (a.reference) return -1
    if (b.reference) return 1
    return a.period.label.localeCompare(b.period.label)
}

function aggregaSorter(a, b) {
    return a.activity.label.localeCompare(b.activity.label)
}

function commitmentAggregator(reference) {
    return (result, commitment) => {
        const aggrega = result.find((a) => a.activity.uid == commitment.activityUid)
        if (aggrega) {
            aggrega.interventionPeriods = commitment.interventionPeriods.sort(interventionPeriodSorter),
            aggrega.referenceInterventionPeriod = commitment.interventionPeriods.find((ip) => ip.reference)
            return result
        }

        const resultActivity =  reference.find((a) => a.uid == commitment.activityUid)
        if (resultActivity) {
            const aggrega = {
                activity: resultActivity,
                interventionPeriods: commitment.interventionPeriods.sort(interventionPeriodSorter),
                referenceInterventionPeriod: commitment.interventionPeriods.find((ip) => ip.reference),
                incidentTypes: []
            }

            result.push(aggrega)
        } else {
            console && console.warn('activity "' + commitment.activityUid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

function activityAggregator(activityReference, openingTicketPurposeReference) {
    return (result, activity) => {
        const incidentTypes = activity.includedIncidentTypes.reduce((result, incidentTypeId) => {
            const resultIncidentType = openingTicketPurposeReference.openingTicketPurposes.find((otp) => otp.uid == incidentTypeId)

            if (resultIncidentType) {
                result.push(resultIncidentType)
            } else {
                console && console.warn('openingTicketPurpose "' + incidentTypeId + '" doesn\'t exist in referentiel')
            }
            return result
        }, [])

        const aggrega = result.find((a) => a.activity.uid == activity.activityUid)
        if (aggrega) {
            aggrega.incidentTypes = incidentTypes
            return result
        }

        const resultActivity =  activityReference.find((a) => a.uid == activity.activityUid)
        if (resultActivity) {
            const aggrega = {
                activity: resultActivity,
                interventionPeriods: [],
                referenceInterventionPeriod: [],
                incidentTypes: incidentTypes
            }

            result.push(aggrega)
        } else {
            console && console.warn('activity "' + activity.activityUid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

class CommitmentLayout extends Component {
    static propTypes = {
        committed: PropTypes.object.isRequired,
        commitments: PropTypes.array.isRequired,
        activities: PropTypes.array,
        activityReference: PropTypes.array.isRequired,
        openingTicketPurposeReference: PropTypes.object
    }

    static defaultProps = {
        activities: []
    }

    constructor(props) {
        super(props)

        this.state = {
            activityAggregation: []
        }
    }

    componentWillMount() {
        const {activityReference, openingTicketPurposeReference, commitments, activities} = this.props

        const commitmentAggregation = commitments.reduce(commitmentAggregator(activityReference), [])
        const unsortedActivityAggregation = activities.reduce(activityAggregator(activityReference, openingTicketPurposeReference), commitmentAggregation)
        const activityAggregation = unsortedActivityAggregation.sort(aggregaSorter)
        const activeAggrega = activityAggregation[0]

        this.setState({activityAggregation, activeAggrega})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activityReference != this.props.activityReference
            || nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference
            || nextProps.commitments != this.props.commitments
            || nextProps.activities != this.props.activities) {
            const {activityReference, openingTicketPurposeReference, commitments, activities} = nextProps
            const {activeAggrega} = this.state

            const commitmentAggregation = commitments.reduce(commitmentAggregator(activityReference), [])
            const unsortedActivityAggregation = activities.reduce(activityAggregator(activityReference, openingTicketPurposeReference), commitmentAggregation)
            const activityAggregation = unsortedActivityAggregation.sort(aggregaSorter)
            const nextActiveAggrega = activeAggrega && activityAggregation.find((a) => a.activity.uid == activeAggrega.activity.uid) || activityAggregation[0]
            
            this.setState({activityAggregation, activeAggrega: nextActiveAggrega})
        }
    }

    _select(event, activeAggrega) {
        event.preventDefault()

        this.setState({activeAggrega})
    }

    _openPanel(key) {
        const {activeKey} = this.state

        const nextActiveKey = activeKey != key && key || null
        this.setState({activeKey: nextActiveKey})
    }

    _openModal(event, result, activeInterventionPeriod) {
        if (event) {
            event.preventDefault()
        }

        const openedModal = modalName(result)
        this.setState({openedModal, activeInterventionPeriod})
    }

    _closeModal(event, result, activity) {
        const {activityAggregation, activeAggrega} = this.state

        if (event) {
            event.preventDefault()
        }

        const nextActiveAggrega = activity && activityAggregation.find((a) => a.activity.uid == activity.uid) || activeAggrega
        this.setState({openedModal: null, activeAggrega: nextActiveAggrega})
    }

    render() {
        const {dispatch, committed, commitments, activityReference, openingTicketPurposeReference} = this.props
        const {activityAggregation, activeKey, activeAggrega, activeInterventionPeriod, openedModal} = this.state

        const tooltip = (text) => (
            <Tooltip
                className='tooltip-danger'>
                {text}
            </Tooltip>
        )

        return (
            <div>
                <Row>
                    <Col sm={8}>
                        {activeAggrega && (
                            <div className={style.main}>
                                <h4>
                                    <span>{activeAggrega.activity.label}</span>
                                    {committed._links.find(linkFinder('UnAssignActivityFromProviderCompany')) && (
                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={tooltip(i18n.unAssignActivity)}>
                                            <Button
                                                bsStyle='link'
                                                onClick={(e) => this._openModal(e, 'UnAssignActivityFromProviderCompanyModal')}>
                                                <Icon icon='minus' size='xs' />
                                            </Button>
                                        </OverlayTrigger>
                                    )}
                                </h4>
                                <PanelGroup accordion
                                    activeKey={activeKey}
                                    onSelect={(k) => this._openPanel(k)}>
                                    {activeAggrega.interventionPeriods.map((interventionPeriod) => (
                                        <UpdateInterventionPeriodPanel
                                            key={interventionPeriod.uid}
                                            eventKey={interventionPeriod.uid}
                                            committed={committed}
                                            activity={activeAggrega.activity}
                                            interventionPeriod={interventionPeriod}
                                            referenceInterventionPeriod={activeAggrega.referenceInterventionPeriod}
                                            incidentTypes={activeAggrega.incidentTypes}
                                            openingTicketPurposeReference={openingTicketPurposeReference}
                                            onSubmit={(e, r, ip) => this._openModal(e, r, ip)} />
                                    ))}
                                    {committed._links.find(linkFinder(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])) && activeKey == 'new' && (
                                        <DefineInterventionPeriodPanel
                                            eventKey='new'
                                            committed={committed}
                                            activity={activeAggrega.activity}
                                            interventionPeriods={activeAggrega.interventionPeriods}
                                            onSubmit={(e, r, ip) => this._openModal(e, r, ip)} />
                                    )}
                                </PanelGroup>
                                <ButtonToolbar>
                                    {committed._links.find(linkFinder(['DefineInterventionPeriodForActivity', 'DefineInterventionPeriod'])) && activeKey != 'new' && (
                                        <Button
                                            bsStyle='primary'
                                            bsSize='large'
                                            onClick={() => this._openPanel('new')}>
                                            {i18n.newInterventionPeriod}
                                        </Button>
                                    )}
                                    {activeAggrega.interventionPeriods.length == 0 && (
                                        <Button
                                            bsStyle='primary'
                                            bsSize='large'
                                            onClick={(e) => this._openModal(e, 'CopyInterventionPeriodsModal')}>
                                            {i18n.fillinAssistant}
                                        </Button>
                                    )}
                                </ButtonToolbar>
                            </div>
                        )}
                    </Col>
                    <Col sm={4}>
                        <div className={style.side}>
                            <h4>{activityAggregation.length} {i18n.activitiez}</h4>
                            <ul className={style.activityGroup}>
                                {activityAggregation.map((aggrega) => (
                                    <li
                                        key={aggrega.activity.uid}>
                                        <a
                                            href=''
                                            onClick={(e) => this._select(e, aggrega)}>
                                            {aggrega.activity.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                            {committed._links.find(linkFinder('AssignActivityToProviderCompany')) && (
                                <ButtonToolbar>
                                    <Button
                                        bsStyle='primary'
                                        bsSize='large'
                                        onClick={(e) => this._openModal(e, 'AssignActivityToProviderCompanyModal')}>
                                        {i18n.assignActivity}
                                    </Button>
                                </ButtonToolbar>
                            )}
                        </div>
                    </Col>
                </Row>
                {committed._links.find(linkFinder('AssignActivityToProviderCompany')) && (
                    <AssignActivityToProviderCompanyModal
                        show={openedModal == 'AssignActivityToProviderCompanyModal'}
                        onHide={(e, r, a) => this._closeModal(e, r, a)} />
                )}
                {activeAggrega && committed._links.find(linkFinder('UnAssignActivityFromProviderCompany')) && (
                    <UnAssignActivityFromProviderCompanyModal
                        activity={activeAggrega.activity}
                        show={openedModal == 'UnAssignActivityFromProviderCompanyModal'}
                        onHide={() => this._closeModal()} />
                )}
                {activeAggrega && activeInterventionPeriod && committed._links.find(linkFinder('RemoveInterventionPeriod')) && (
                    <RemoveInterventionPeriodModal
                        committed={committed}
                        activity={activeAggrega.activity}
                        interventionPeriod={activeInterventionPeriod}
                        show={openedModal == 'RemoveInterventionPeriodModal'}
                        onHide={() => this._closeModal()} />
                )}
                {activeAggrega && (
                    <CopyInterventionPeriodsModal
                        committed={committed}
                        commitments={commitments}
                        activity={activeAggrega.activity}
                        show={openedModal == 'CopyInterventionPeriodsModal'}
                        onHide={() => this._closeModal()} />
                )}
            </div>
        )
    }
}

export default CommitmentLayout


// WEBPACK FOOTER //
// ./lib/provider/components/CommitmentLayout.js